import React, { forwardRef } from "react";
import PT from "prop-types";
import { PLACEHOLDER_IMAGE_PATH } from "@/misc/constants";
import * as S from "./styled";
import StarIcon from "_c/icon/Star";
import ShareIcon from "_c/icon/Share";
import CommentIcon from "_c/icon/Comment";

const PortfolioSlide = forwardRef(
  (
    {
      removing,
      isOwner,
      isAuth,
      slide,
      url,
      onRemove,
      onStarClick,
      onClick,
      onShare,
      visible,
      isFavorite,
      t,
      altText,
    },
    ref
  ) => (
    <S.Slide ref={ref} onClick={onClick}>
      <S.MetaWrap isOwner={isOwner}>
        <S.Meta
          className="slider-meta"
          onClick={isAuth && onStarClick}
          title={isFavorite ? t("common:remove_like") : t("common:like")}
          count={slide.likes_count}
        >
          <StarIcon filled={isFavorite} color="var(--color-primary)" />
        </S.Meta>
        <S.Meta
          onClick={onShare}
          title={t("common:share")}
          className="slider-meta"
        >
          <ShareIcon color="var(--color-primary)" />
        </S.Meta>
        <S.Meta
          className="slider-meta"
          onClick={null}
          count={slide.comments_count}
        >
          <CommentIcon width="17" color="var(--color-primary)" />
        </S.Meta>
      </S.MetaWrap>
      <S.Img alt={altText} src={visible ? url : PLACEHOLDER_IMAGE_PATH} />
      {isOwner && (
        <S.RemoveBtn disabled={removing} onClick={onRemove}>
          {t("common:remove")}
        </S.RemoveBtn>
      )}
    </S.Slide>
  )
);
PortfolioSlide.propTypes = {
  isOwner: PT.bool,
  slide: PT.object,
  isAuth: PT.bool,
  url: PT.string,
  isFavorite: PT.bool,
  removing: PT.bool.isRequired,

  t: PT.func.isRequired,
  onStarClick: PT.func.isRequired,
  onClick: PT.func.isRequired,
  onRemove: PT.func.isRequired,
  onShare: PT.func.isRequired,
};

export default PortfolioSlide;
